import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom"
//@ts-ignore
import _ from "lodash";
import {checkEmpty} from "src/service/util.service";
import * as GroupAPI from "../../../../service/group.service";
import InfiniteScroll from "react-infinite-scroll-component";

import styles from "./GroupFileContainer.module.scss";
import SkeletonCard from "src/pages/Group/CardGroup/SkeletonCard";
import GroupCardFile from "../../component/GroupCardFile";
import NoData from "src/components/shared/NoDataDisplay/NoData";
import {nodataFile} from "src/props/util.props";
import {useTranslation} from "react-i18next";

const defaultLitmitOfset = 15;

const GroupFileContainer = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [folders, setFolders]: any = useState(null);
  const [files, setFiles]: any = useState(null);
  const [offset, setOffset]: any = useState(0);
  const [search, setSearch]: any = useState("");
  const [myGroup, setMyGroup]: any = useState([]);
  const [hasMore, setHasMore]: any = useState(false);
  const [loading, setLoading]: any = useState(false);
  const [loadMore, setLoadMore]: any = useState(false);
  const [total, setTotal]: any = useState(0);

  const loadMyGroup = async (search: string, limit: number, offset: number) => {
    const { data } = await GroupAPI.findMyGroup(search, limit, offset, null);
    return data;
  };
  // const getGroup = async () => {
  //   const data = await loadMyGroup(search, defaultLitmitOfset, offset);
  //   setMyGroup(data?.groups);
  //   setTotal(data?.total);
  //   checkHasMore(data?.groups?.length, data?.total);
  // };

  useEffect(() => {
    setOffset(0);
  }, [search]);

  const checkHasMore = (currentTotal: number, total: number) => {
    if (currentTotal + defaultLitmitOfset >= total) setHasMore(false);
  };

  function fetchNext() {
    console.log(" fetchNext ");
    fetchNextGroup();
  }
  function fetchNextGroup() {
    if (myGroup?.length + defaultLitmitOfset >= total) {
      console.log(" hasmore  false ");
      setHasMore(false);
    }
    if (myGroup?.length >= total) {
      console.log(" hasmore  false ");
      setHasMore(false);
    }
    if (myGroup?.length < total) {
      console.log(" hasmore  true ");
      setHasMore(true);
      setOffset(offset + defaultLitmitOfset);
    }
  }

  useEffect(() => {
    fetchNextData();
  }, [offset]);

  useEffect(() => {
    fetchNextData();
  }, []);

  const fetchNextData = async () => {
    if (offset === 0) setMyGroup([]);

    checkHasMore(myGroup?.length, total);

    // if (myGroup?.length < total) {
    setLoading(true);
    const comingGroup = await loadMyGroup(search, defaultLitmitOfset, offset);
    setLoading(false);
    setMyGroup((prev: any) => {
      if (offset === 0) return comingGroup.groups;
      if (checkEmpty(prev)) prev = [];
      return [...prev, ...comingGroup.groups];
    });
    setTotal(comingGroup.total);
    if (offset === 0) {
      setHasMore(true);
      setLoadMore(false);
    }
    // console.log("comingGroup",comingGroup)
    if (comingGroup.total === 0 || checkEmpty(comingGroup.total)) {
      setHasMore(false);
    }

    if (myGroup.length + defaultLitmitOfset >= comingGroup.total) {
      setHasMore(false);
    }

    // }
  };

  return (
    <>
      <InfiniteScroll
        dataLength={myGroup !== null ? myGroup?.length : 0}
        next={fetchNext}
        hasMore={hasMore}
        scrollableTarget={"FileFoldersContainer"}
        loader={
          !hasMore ? null : (
            <div className={styles.cardGroup}>
              <SkeletonCard />
            </div>
          )
        }
        className={styles.customInfinitscroll}
      >
        <div className={styles.cardGroup}>
          {loading && !loadMore && <SkeletonCard />}
          {myGroup !== null &&
            myGroup?.map((group: any, idx: number) => {
              return (
                <GroupCardFile
                  key={idx}
                  image={group.coverImgURL}
                  member={group.totalMember}
                  groupName={group.name}
                  favorite={idx % 2 === 0}
                  joined={true}
                  groupID={group.id}
                  group={group}
                />
              );
            })}
         
        </div>
        {!loading && (myGroup?.length === 0 || checkEmpty(myGroup) ) && (
            // <div className={styles.textEmpty}>{t("Empty")}</div>
            <NoData
              header={t(nodataFile.noDataHeaderTextGroup)}
              detail={t(nodataFile.nodatatextGroupH) + ", " + t(nodataFile.nodatatextGroupL) + "."}
            />
          )}
      </InfiniteScroll>
    </>
  );
};

export default GroupFileContainer;
